export interface IAthleteCreateInput {
  first_name: string;
  last_name: string;
  email: string;
  gender: string;
  default_weight?: number;
  default_height?: number;
  dob?: string;
  training_level?: number;
  group?: number | null;
}

export interface IAthleteUpdateInput extends Partial<IAthleteCreateInput> {
  group?: number | null;
}

/**
 * Payload for PUT athletes/{id}/ — the endpoint that accepts the photo. This is
 * a full replace, so every field the GET response carries must ride along
 * (the backend resets anything omitted, e.g. is_active/is_count), not just the
 * fields the edit form exposes. The photo rides along as a File when the user
 * picks a new one.
 */
export interface IAthleteFullUpdateRequest {
  first_name: string;
  last_name: string;
  gender: string;
  dob: string;
  email: string;
  email2: string;
  phone: string;
  phone2: string;
  fax: string;
  address_street_name: string;
  address_street_number: string;
  address_zip: string;
  address_city: string;
  address_state: string;
  address_country_id: string;
  website: string;
  facebook: string;
  twitter: string;
  instagram: string;
  is_active: boolean;
  is_count: boolean;
  default_weight: number | null;
  default_height: number | null;
  group: number | null;
  training_level: number | null;
  organization: number;
  photo?: File;
}

export interface ITrainingLevel {
  id: number;
  value: string;
  is_default_level: boolean;
  organization: number | null;
}

export interface ITrainingLevelCategory {
  readonly id: number;
  readonly name: string;
  readonly slotName: string;
  readonly isConfigured: boolean;
}

export const EMPTY_TRAINING_LEVELS: ITrainingLevel[] = [];

export interface IAthlete {
  id: number;
  tags: any[];
  coaches: any[];
  equipment: any[];
  first_name: string;
  last_name: string;
  gender: string;
  dob: string;
  photo: string;
  address_street_name: string;
  address_street_number: string;
  address_zip: string;
  address_city: string;
  address_state: string;
  address_country_id: string;
  phone: string;
  phone2: string;
  fax: string;
  email: string;
  email2: string;
  website: string;
  facebook: string;
  twitter: string;
  instagram: string;
  is_active: true;
  default_weight: number;
  default_height: number;
  garmin_verified: boolean;
  group: null | number;
  strava_id: number;
  inactive_expiration: any;
  is_count: boolean;
  count_date: any;
  plan_id: any;
  active_purchase_detail_id: number;
  product_id: any;
  link_item_id: any;
  created_at: string;
  updated_at: string;
  deleted_at: any;
  is_delete: boolean;
  is_invisible: boolean;
  display_id: number;
  external_athlete_id: number;
  organization: number;
  training_level: number;
  created_by: any;
  training_level_value: string;
  latest_sport_id: number;
  latest_body_fat: number;
}
